module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/chart-bar-2-419679428dc0c9cd78c8a12bdf335ac9.svg";